module.exports = __webpack_public_path__ + "1P-Icons.03fec87261a5179212cf.ttf";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/images/fonts/1P-Icons.ttf
// module id = ../../../../../src/assets/images/fonts/1P-Icons.ttf
// module chunks = styles